export const style = {
  textCenter: {
    textAlign: 'center',
    minHeight: '110vh',
    maxHeight: '65vh',
  },
  container: {
    overflow: 'auto',
  },
  textMuted: {
    color: '#6c757d',
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    fontWeight: 'bold',
    fontFamily: "'Nunito', 'Helvetica', 'Arial', sans-serif",
    textDecoration: 'none',
  },
  selector: {
    color: 'red',
    flex: 'auto',
    margin: '10px',
    display: 'flex',
  },
  table: {
    fontSize: '12px',
  },
  noPrint: {
    display: 'none',  
  },
  modalPrint: {
    width: '100%',
    height: '100%',
    pageBreakAfter: 'always',
  },
}
